
import { client } from './client'
import { normalizeStatisticsResponse, normalizeBehaviorResponse, createUserUpdatePayload } from './normalize'
import { createSimpleResponse } from '../response'

const fetchUser = async () => {
  try {
    let response = await client.get('/v1/user')
    return response.data
  } catch (error) {
    throw error
  }
}

/**
 * Updates user information.
 * user object can be complete object from store, only partial fields also legal
 * @param {object} user
 */
const updateUser = async (user) => {
  try {
    let response = await client.put('/v1/user/profile', createUserUpdatePayload(user))
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchBehavior = async () => {
  try {
    let response = await client.get('/v1/user/behaviors')
    let result = normalizeBehaviorResponse(response.data)
    return result
  } catch (error) {
    throw error
  }
}

const fetchStatistics = async () => {
  try {
    let response = await client.get('/v1/user/statistics')
    return normalizeStatisticsResponse(response.data)
  } catch (error) {
    throw error
  }
}

const fetchTopDestinations = async (topDestinationsRequest) => {
  try {
    let resource = `/v1/topdestinations/country/${topDestinationsRequest.geolocation}/${topDestinationsRequest.take}`
    let response = await client.get(resource)
    return createSimpleResponse(response.data.countries)
  } catch (error) {
    throw error
  }
}

const fetchInvite = async () => {
  try {
    let resource = `/v1/user/invite?utmMedium=web`
    let response = await client.get(resource)
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  fetchUser,
  updateUser,
  fetchBehavior,
  fetchStatistics,
  fetchTopDestinations,
  fetchInvite
}



// WEBPACK FOOTER //
// ./src/api/proxy/index.js